import androidx.compose.animation.AnimatedVisibility
import androidx.compose.animation.AnimatedVisibilityScope
import androidx.compose.animation.core.RepeatMode
import androidx.compose.animation.core.FastOutSlowInEasing
import androidx.compose.animation.core.StartOffset
import androidx.compose.animation.core.Spring
import androidx.compose.animation.core.animateFloatAsState
import androidx.compose.animation.core.animateFloat
import androidx.compose.animation.core.infiniteRepeatable
import androidx.compose.animation.core.keyframes
import androidx.compose.animation.core.rememberInfiniteTransition
import androidx.compose.animation.core.spring
import androidx.compose.animation.core.tween
import androidx.compose.animation.expandHorizontally
import androidx.compose.animation.fadeIn
import androidx.compose.animation.fadeOut
import androidx.compose.animation.shrinkHorizontally
import androidx.compose.foundation.LocalIndication
import androidx.compose.foundation.clickable
import androidx.compose.foundation.interaction.MutableInteractionSource
import androidx.compose.foundation.interaction.collectIsHoveredAsState
import androidx.compose.foundation.interaction.collectIsPressedAsState
import androidx.compose.foundation.layout.Arrangement
import androidx.compose.foundation.layout.Box
import androidx.compose.foundation.layout.BoxWithConstraints
import androidx.compose.foundation.layout.Column
import androidx.compose.foundation.layout.Row
import androidx.compose.foundation.layout.WindowInsets
import androidx.compose.foundation.layout.displayCutout
import androidx.compose.foundation.layout.fillMaxSize
import androidx.compose.foundation.layout.fillMaxWidth
import androidx.compose.foundation.layout.padding
import androidx.compose.foundation.layout.statusBars
import androidx.compose.foundation.shape.CircleShape
import androidx.compose.foundation.shape.RoundedCornerShape
import androidx.compose.material.Scaffold
import androidx.compose.material.icons.Icons
import androidx.compose.material.icons.filled.Favorite
import androidx.compose.material.icons.filled.Folder
import androidx.compose.material.icons.filled.Home
import androidx.compose.material.icons.filled.PlayArrow
import androidx.compose.material.icons.filled.Settings
import androidx.compose.material.icons.outlined.Folder
import androidx.compose.material.icons.outlined.FavoriteBorder
import androidx.compose.material.icons.outlined.Home
import androidx.compose.material.icons.outlined.PlayArrow
import androidx.compose.material.icons.outlined.Settings
import androidx.compose.material3.Icon
import androidx.compose.material3.LocalContentColor
import androidx.compose.material3.MaterialTheme
import androidx.compose.material3.Surface
import androidx.compose.material3.Text
import androidx.compose.runtime.*
import androidx.compose.runtime.saveable.Saver
import androidx.compose.runtime.saveable.rememberSaveable
import androidx.compose.ui.Alignment
import androidx.compose.ui.Modifier
import androidx.compose.ui.draw.rotate
import androidx.compose.ui.draw.scale
import androidx.compose.ui.draw.drawWithContent
import androidx.compose.ui.geometry.Offset
import androidx.compose.ui.graphics.BlendMode
import androidx.compose.ui.graphics.Brush
import androidx.compose.ui.graphics.CompositingStrategy
import androidx.compose.ui.graphics.graphicsLayer
import androidx.compose.ui.graphics.Color
import androidx.compose.ui.graphics.vector.ImageVector
import androidx.compose.ui.layout.ContentScale
import androidx.compose.ui.platform.LocalDensity
import androidx.compose.ui.platform.LocalLayoutDirection
import androidx.compose.ui.text.font.FontStyle
import androidx.compose.ui.text.font.FontFamily
import androidx.compose.ui.text.font.FontWeight
import androidx.compose.ui.text.style.TextOverflow
import androidx.compose.ui.tooling.preview.Preview
import androidx.compose.ui.unit.dp
import androidx.compose.ui.unit.max
import androidx.compose.ui.unit.sp
import androidx.navigation.NavController
import androidx.navigation.NavType
import androidx.navigation.compose.NavHost
import androidx.navigation.compose.rememberNavController
import androidx.navigation.compose.composable
import androidx.navigation.navArgument
import androidx.savedstate.read
import com.alpha.showcase.common.ui.play.mediaMetadataCache
import coil3.ImageLoader
import coil3.compose.LocalPlatformContext
import coil3.compose.setSingletonImageLoaderFactory
import coil3.svg.SvgDecoder
import com.alpha.showcase.common.addPlatformComponents
import coil3.disk.DiskCache
import coil3.memory.MemoryCache
import coil3.request.maxBitmapSize
import coil3.request.crossfade
import coil3.size.Size as CoilSize
import coil3.util.Logger
import coil3.util.Logger.Level
import com.alpha.showcase.common.components.BackHandler
import com.alpha.showcase.common.ui.ai.AI_PROVIDER_ROUTE
import com.alpha.showcase.common.ui.ai.AI_CREATIONS_ROUTE
import com.alpha.showcase.common.ui.ai.aiCreationDestinations
import com.alpha.showcase.common.ui.ai.aiProviderDestination
import com.alpha.showcase.common.mtphoto.MTPhotoFetcher
import com.alpha.showcase.common.mtphoto.MTPhotoFileKeyer
import com.alpha.showcase.common.networkfile.storage.remote.RemoteApi
import com.alpha.showcase.common.theme.AppTheme
import com.alpha.showcase.common.toast.ToastHost
import com.alpha.showcase.common.toast.ToastScope
import com.alpha.showcase.common.ui.confetti.ConfettiController
import com.alpha.showcase.common.ui.confetti.ConfettiType
import com.alpha.showcase.common.ui.confetti.GlobalConfettiHost
import com.alpha.showcase.common.ui.ext.ResolvedImageFetcher
import com.alpha.showcase.common.ui.ext.handleBackKey
import com.alpha.showcase.common.ui.play.PlayPage
import com.alpha.showcase.common.ui.play.shouldOpenExternalPlaybackWindow
import com.alpha.showcase.common.ui.settings.SettingsListView
import com.alpha.showcase.common.ui.settings.donationAction
import com.alpha.showcase.common.ui.settings.SettingsViewModel
import com.alpha.showcase.common.ui.source.SourceListView
import com.alpha.showcase.common.ui.source.SourceViewModel
import com.alpha.showcase.common.update.AppUpdateDialogHost
import com.alpha.showcase.common.update.AppUpdateViewModel
import com.alpha.showcase.common.ui.config.ConfigScreen
import com.alpha.showcase.common.ui.focusScaleEffect
import com.alpha.showcase.common.ui.tvScreenFocus
import com.alpha.showcase.common.ui.layout.homeHorizontalPaddingDp
import com.alpha.showcase.common.ui.view.DURATION_ENTER
import com.alpha.showcase.common.ui.view.DURATION_EXIT
import com.alpha.showcase.common.ui.view.LottieAssetLoader
import com.alpha.showcase.common.ui.view.rememberMobileHaptic
import com.alpha.showcase.common.ui.vm.UiState
import com.alpha.showcase.common.utils.Log
import com.alpha.showcase.common.utils.decodeBase64UrlSafe
import com.alpha.showcase.common.utils.encodeBase64UrlSafe
import kotlinx.coroutines.flow.collectLatest
import kotlinx.coroutines.flow.combine
import kotlinx.coroutines.launch
import kotlinx.coroutines.Dispatchers
import kotlinx.coroutines.delay
import okio.Path.Companion.toPath
import org.jetbrains.compose.resources.StringResource
import org.jetbrains.compose.resources.stringResource

import showcaseapp.composeapp.generated.resources.Res
import showcaseapp.composeapp.generated.resources.app_name
import showcaseapp.composeapp.generated.resources.auto_play
import showcaseapp.composeapp.generated.resources.donate
import showcaseapp.composeapp.generated.resources.home
import showcaseapp.composeapp.generated.resources.settings
import showcaseapp.composeapp.generated.resources.sources


val imageCache = getPlatform().getConfigDirectory().toPath().resolve("image_cache")

val LocalImageLoader = compositionLocalOf<ImageLoader?> {
    null
}

@Composable
@Preview
fun MainApp(
    openPlaybackInExternalWindow: Boolean = false,
    onOpenExternalPlaybackWindow: ((RemoteApi) -> Unit)? = null,
    fontFamily: FontFamily = FontFamily.Default,
    startupError: String? = null,
) {
    if (startupError != null) {
        AppTheme {
            Surface(modifier = Modifier.fillMaxSize()) {
                Box(
                    modifier = Modifier.fillMaxSize().padding(24.dp),
                    contentAlignment = Alignment.Center,
                ) {
                    Text(
                        text = "Unable to open encrypted configuration. Existing data was not changed. " +
                            "Please repair or clear this site's local data, then reload.\n\n$startupError",
                    )
                }
            }
        }
        return
    }

    var showLaunchAnimation by remember {
        mutableStateOf(true)
    }


    var firstOpen by remember {
        mutableStateOf(true)
    }

    val generalPreferenceState by SettingsViewModel.generalPreferenceFlow.collectAsState()
    var startupUpdateCheckHandled by remember {
        mutableStateOf(false)
    }

    LaunchedEffect(generalPreferenceState) {
        if (startupUpdateCheckHandled) return@LaunchedEffect
        val preference = (generalPreferenceState as? UiState.Content)?.data ?: return@LaunchedEffect
        startupUpdateCheckHandled = true
        if (preference.autoCheckUpdate && shouldRunAutomaticUpdateCheck()) {
            AppUpdateViewModel.checkForUpdate()
        }
    }

    ShowcaseAppProviders(fontFamily) {
        val scope = rememberCoroutineScope()
        val navController = rememberNavController()

        Box(
            Modifier.fillMaxSize()
        ) {
            NavHost(
                navController = navController,
                startDestination = Screen.Home.route,
                Modifier.fillMaxSize()
            ) {
                composable(
                    Screen.Home.route
                ) {
                    HomePage(navController)
                }
                aiProviderDestination(navController)
                aiCreationDestinations(navController)
                composable(
                    "${Screen.Play.route}/{sourceName}",
                    arguments = listOf(navArgument("sourceName") { type = NavType.StringType })
                ) { backStackEntry ->
                    val sourceName = remember(backStackEntry) {
                        runCatching {
                            backStackEntry.arguments
                                ?.read { getStringOrNull("sourceName") }
                                ?.takeIf { it.isNotBlank() }
                                ?.decodeBase64UrlSafe()
                        }.getOrNull().orEmpty()
                    }
                    val source = remember<RemoteApi?>(sourceName) {
                        if (sourceName.isBlank()) null else SourceViewModel.getSource(sourceName)
                    }
                    if (source == null) {
                        LaunchedEffect(sourceName) {
                            navController.popBackStack()
                        }
                    } else {
                        val shouldUseExternalWindow = shouldOpenExternalPlaybackWindow(
                            autoFullscreen = openPlaybackInExternalWindow,
                            hasExternalPlaybackWindow = onOpenExternalPlaybackWindow != null
                        )
                        if (shouldUseExternalWindow) {
                            LaunchedEffect(source) {
                                onOpenExternalPlaybackWindow?.invoke(source)
                                navController.popBackStack()
                            }
                        } else {
                            PlayPage(source) {
                                if (navController.currentBackStackEntry?.destination?.route?.startsWith(
                                        Screen.Play.route
                                    ) == true
                                ) {
                                    navController.popBackStack()
                                }

                                if (SettingsViewModel.generalPreferenceFlow.value is UiState.Content) {
                                    val preference =
                                        (SettingsViewModel.generalPreferenceFlow.value as UiState.Content).data
                                    scope.launch {
                                        SettingsViewModel.updatePreference(
                                            preference.copy(
                                                latestSource = source.name
                                            ),
                                            expectedPreference = preference,
                                        )
                                    }
                                }
                            }
                        }
                    }
                }
                composable(
                    "${Screen.Config.route}/{type}?sourceName={sourceName}",
                    arguments = listOf(
                        navArgument("type") { type = NavType.IntType },
                        navArgument("sourceName") {
                            type = NavType.StringType; defaultValue = ""
                        }
                    )
                ) { backStackEntry ->
                    val configType =
                        backStackEntry.arguments?.read { getIntOrNull("type") } ?: 0
                    val sourceName = runCatching {
                        backStackEntry.arguments
                            ?.read { getStringOrNull("sourceName") }
                            ?.takeIf { it.isNotBlank() }
                            ?.decodeBase64UrlSafe()
                    }.getOrNull().orEmpty()
                    val editSource = remember(sourceName) {
                        if (sourceName.isBlank()) null else SourceViewModel.getSource(sourceName)
                    }
                    ConfigScreen(type = configType, editSource = editSource) {
                        navController.popBackStack()
                    }
                }
            }

            LaunchedEffect(Unit) {
                SettingsViewModel.settingsFlow.combine(SettingsViewModel.generalPreferenceFlow) { settings, preference ->
                    if (settings is UiState.Content && preference is UiState.Content) {
                        settings.data.autoOpenLatestSource to preference.data.latestSource
                    } else false to ""
                }.collectLatest {
                    val (autoOpen, latestSource) = it
                    if (autoOpen && latestSource.isNotBlank() && firstOpen) {
                        Log.d("autoOpen: $autoOpen, latestSource: $latestSource")
                        delay(5000)
                        SourceViewModel.getSource(latestSource)?.apply {
                            navController.navigate("${Screen.Play.route}/${name.encodeBase64UrlSafe()}")
                        }
                        firstOpen = false
                    }
                }
            }
            ToastHost()
            AppUpdateDialogHost()
            GlobalConfettiHost()
        }

        FadeAnimatedVisibility(showLaunchAnimation) {
            LaunchAnimationScreen {
                showLaunchAnimation = false
            }
        }
    }
}

@Composable
fun ShowcaseAppProviders(
    fontFamily: FontFamily = FontFamily.Default,
    content: @Composable () -> Unit,
) {
    val generalPreferenceState by SettingsViewModel.generalPreferenceFlow.collectAsState()
    val currentGeneralPreference = (generalPreferenceState as? UiState.Content)?.data
        ?: com.alpha.showcase.common.ui.settings.GeneralPreference(0, 0)

    val context = LocalPlatformContext.current

    val imageLoader = remember(context, currentGeneralPreference.cacheSize) {
        ImageLoader.Builder(context)
            .crossfade(true)
            .maxBitmapSize(CoilSize(2560, 2560))
            .fetcherCoroutineContext(Dispatchers.Default.limitedParallelism(8))
            .decoderCoroutineContext(Dispatchers.Default.limitedParallelism(4))
            .mediaMetadataCache(
                MemoryCache.Builder()
                    .maxSizePercent(context, 0.25)
                    .build()
            ) {
                add(MTPhotoFileKeyer())
                add(MTPhotoFetcher.Factory())
                add(ResolvedImageFetcher.Factory())
                add(SvgDecoder.Factory())
                addPlatformComponents()
            }
            .apply {
                if (!isWeb()) {
                    diskCache {
                        DiskCache.Builder()
                            .directory(imageCache)
                            .maxSizeBytes(currentGeneralPreference.cacheSize * 1024 * 1024L)
                            .build()
                    }
                }
            }
            .logger(
                object : Logger {
                    override var minLevel = Level.Info

                    override fun log(
                        tag: String,
                        level: Logger.Level,
                        message: String?,
                        throwable: Throwable?
                    ) {
//                        message?.apply {
//                            Log.i(message)
//                        }

                        throwable?.apply {
                            throwable.printStackTrace()
                        }
                    }
                }
            )
            .build()
    }

    androidx.compose.runtime.SideEffect {
        com.alpha.showcase.common.cache.SourceDerivedCache.imageLoader = imageLoader
    }
    setSingletonImageLoaderFactory { _ ->
        imageLoader
    }

    AppTheme(fontFamily) {
        CompositionLocalProvider(LocalImageLoader provides imageLoader) {
            Box(Modifier.fillMaxSize()) {
                com.alpha.showcase.common.ui.ai.AiNavigationHost { content() }
                // Outside both navigation hosts so tool pages cannot cover global messages.
                ToastHost(scope = ToastScope.GLOBAL)
            }
        }
    }
}

@Composable
fun LaunchAnimationScreen(onFinished: () -> Unit) {
    Surface(
        modifier = Modifier.fillMaxSize()
    ) {
        Box(
            modifier = Modifier.fillMaxSize(),
            contentAlignment = Alignment.Center
        ){
            LottieAssetLoader(
                lottieAsset = "lottie/lottie_launch.json",
                modifier = Modifier.fillMaxSize(0.3f),
                iterations = 1,
                contentScale = ContentScale.Fit,
                onFinished = onFinished
            )
        }
    }
}

@Composable
fun FadeAnimatedVisibility(
    visible: Boolean,
    modifier: Modifier = Modifier,
    durationMillis: Int = 400,
    content: @Composable AnimatedVisibilityScope.() -> Unit
) {
    AnimatedVisibility(
        visible = visible,
        modifier = modifier,
        enter = fadeIn(animationSpec = tween(durationMillis = durationMillis)),
        exit = fadeOut(animationSpec = tween(durationMillis = durationMillis)),
        content = content
    )
}

@Composable
private fun AnimatedDonationIcon(isInteracting: Boolean) {
    val transition = rememberInfiniteTransition(label = "donation attention")
    val pulse = transition.animateFloat(
        initialValue = 0f,
        targetValue = 0f,
        animationSpec = infiniteRepeatable(
            animation = keyframes {
                durationMillis = 6000
                0f at 0
                0f at 5000 using FastOutSlowInEasing
                1f at 5200
                1f at 5800 using FastOutSlowInEasing
                0f at 6000
            },
            repeatMode = RepeatMode.Restart,
            initialStartOffset = StartOffset(1000),
        ),
        label = "donation pulse",
    )
    val shimmer = transition.animateFloat(
        initialValue = 0f,
        targetValue = 1f,
        animationSpec = infiniteRepeatable(
            animation = keyframes {
                durationMillis = 6000
                0f at 0
                0f at 5200
                1f at 5800
                1f at 6000
            },
            repeatMode = RepeatMode.Restart,
            initialStartOffset = StartOffset(1000),
        ),
        label = "donation shimmer",
    )
    val isFlashing by remember { derivedStateOf { pulse.value > 0.05f } }
    val isFilled = isInteracting || isFlashing
    Icon(
        imageVector = if (isFilled) Icons.Filled.Favorite else Icons.Outlined.FavoriteBorder,
        tint = if (isFilled) Color(0xFFE53935) else LocalContentColor.current,
        contentDescription = stringResource(Res.string.donate),
        modifier = Modifier.graphicsLayer {
            compositingStrategy = CompositingStrategy.Offscreen
            val progress = pulse.value
            scaleX = 1f + 0.16f * progress
            scaleY = 1f + 0.16f * progress
        }.drawWithContent {
            drawContent()
            val progress = shimmer.value
            if (progress > 0f && progress < 1f) {
                // Clip the moving highlight to the heart, including its transparent edges.
                val bandWidth = size.width * 0.65f
                val x = -bandWidth + (size.width + bandWidth * 2) * progress
                drawRect(
                    brush = Brush.linearGradient(
                        colors = listOf(Color.Transparent, Color.White.copy(alpha = 0.9f), Color.Transparent),
                        start = Offset(x - bandWidth, size.height),
                        end = Offset(x + bandWidth, 0f),
                    ),
                    blendMode = BlendMode.SrcAtop,
                )
            }
        },
    )
}

@Composable
@Preview
fun HomePage(nav: NavController) {
    val greeting = remember {
        val greet = Greeting().greet()
        Log.d(greet)
        greet
    }
    var currentDestination by rememberSaveable(stateSaver = Saver<Screen, String>(
        save = { it.route },
        restore = { route -> navItems.firstOrNull { it.route == route } ?: Screen.Sources },
    )) {
        mutableStateOf<Screen>(Screen.Sources)
    }
    val settingSelected by remember {
        derivedStateOf { currentDestination == Screen.Settings }
    }

    BoxWithConstraints(
        modifier = Modifier.fillMaxSize().tvScreenFocus()
    ) {
        val density = LocalDensity.current
        val layoutDirection = LocalLayoutDirection.current
        // 获取顶部安全区域的高度 (推荐方式，包含状态栏和刘海)
        val displayCutoutTop = (WindowInsets.displayCutout.getTop(density) / density.density).dp
        val displayCutoutLeft = (WindowInsets.displayCutout.getLeft(density, layoutDirection) / density.density).dp
        val displayCutoutRight = (WindowInsets.displayCutout.getRight(density, layoutDirection) / density.density).dp
        val statusBars = (WindowInsets.statusBars.getTop(density) / density.density).dp
        val baseHorizontalPadding = homeHorizontalPaddingDp(
            isWeb = isWeb(),
            isDesktop = isDesktop(),
            viewportWidthDp = maxWidth.value,
        ).dp
        val horizontalPadding =
            if (isIos()) baseHorizontalPadding + max(displayCutoutLeft, displayCutoutRight) else baseHorizontalPadding
        // Windows already reserves a draggable title bar above the app content.
        val compactDesktopHeader = isDesktop() && isWindows()
        val topPadding = when {
            isIos() -> max(displayCutoutTop, statusBars)
            isAndroid() -> max(displayCutoutTop, statusBars)
            compactDesktopHeader -> 4.dp
            else -> 26.dp
        }
        val logoVerticalPadding = if (compactDesktopHeader) 4.dp else 12.dp
        val interactionSource = remember { MutableInteractionSource() }
        val isHovered by interactionSource.collectIsHoveredAsState()
        val logoScale by animateFloatAsState(if (isHovered) 1.05f else 1f)
        val settingIconScale by animateFloatAsState(if (settingSelected) 1.1f else 1f)
        val performHaptic = rememberMobileHaptic()

        Scaffold(
            modifier = Modifier.fillMaxSize(),
            topBar = {
            Surface {
                Row(
                    Modifier.fillMaxWidth()
                        .padding(horizontalPadding, topPadding, horizontalPadding, 0.dp),
                    verticalAlignment = Alignment.CenterVertically,
                    horizontalArrangement = Arrangement.SpaceBetween
                ) {

                    Surface(
                        Modifier
                            .padding(horizontal = 16.dp, vertical = logoVerticalPadding).scale(logoScale),
                        shape = RoundedCornerShape(6.dp),
                    ) {
                        Text(
                            modifier = Modifier
                                .focusScaleEffect(
                                    enableShimmer = true,
                                    interactionSource = interactionSource
                                ).clickable(
                                    interactionSource = interactionSource,
                                    indication = null
                                ) {
                                    performHaptic()
                                    currentDestination = Screen.Sources
                                    ConfettiController.trigger(ConfettiType.Celebration)
                                }.padding(10.dp, 4.dp),
                            text = stringResource(Res.string.app_name),
                            fontSize = 32.sp,
                            maxLines = 1,
                            overflow = TextOverflow.Ellipsis,
                            color = MaterialTheme.colorScheme.primary,
                            fontWeight = FontWeight.Bold,
                            fontStyle = FontStyle.Italic,
                        )

                    }
                    val rotation by animateFloatAsState(
                        targetValue = if (settingSelected) 90f else 0f,
                        animationSpec = spring(
                            dampingRatio = Spring.DampingRatioMediumBouncy,
                            stiffness = Spring.StiffnessLow
                        ),
                        label = "icon rotation"
                    )
                    Row(verticalAlignment = Alignment.CenterVertically) {
                        if (getPlatform().supportsDonation) {
                            val onDonate = donationAction()
                            val donationInteractionSource = remember { MutableInteractionSource() }
                            val donationHovered by donationInteractionSource.collectIsHoveredAsState()
                            val donationPressed by donationInteractionSource.collectIsPressedAsState()
                            Surface(
                                shape = CircleShape,
                            ) {
                                Box(
                                    modifier = Modifier
                                        .clickable(
                                            interactionSource = donationInteractionSource,
                                            indication = LocalIndication.current,
                                        ) {
                                            performHaptic()
                                            onDonate()
                                        }
                                        .padding(10.dp),
                                    contentAlignment = Alignment.Center,
                                ) {
                                    AnimatedDonationIcon(isInteracting = donationHovered || donationPressed)
                                }
                            }
                        }
                        Surface(
                            Modifier.padding(12.dp, 0.dp).scale(settingIconScale),
                            shape = CircleShape,
                            tonalElevation = if (settingSelected) 1.dp else 0.dp,
                            shadowElevation = if (settingSelected) 1.dp else 0.dp
                        ) {
                            Box(
                                modifier = Modifier
                                    .clickable {
                                        performHaptic()
                                        currentDestination = if (!settingSelected) {
                                            Screen.Settings
                                        } else {
                                            Screen.Sources
                                        }
                                    }
                                    .handleBackKey {
                                        currentDestination = Screen.Sources
                                    }
                                    .padding(10.dp),
                                contentAlignment = Alignment.Center,
                            ) {
                                Icon(
                                    modifier = Modifier.rotate(rotation),
                                    imageVector = if (settingSelected) Icons.Filled.Settings else Icons.Outlined.Settings,
                                    contentDescription = Screen.Settings.route,
                                    tint = if (settingSelected) MaterialTheme.colorScheme.primary else LocalContentColor.current
                                )
                            }

                        }
                    }
                }

            }

            }) {
            Surface {
            BackHandler(enabled = !usesRemoteNavigation() || currentDestination != Screen.Sources, onBack = {
                if (currentDestination != Screen.Sources) {
                    currentDestination = Screen.Sources
                    return@BackHandler true
                }
                false
            })
            Column(
                Modifier.fillMaxSize().padding(horizontalPadding, 0.dp),
                horizontalAlignment = Alignment.CenterHorizontally
            ) {

                AnimatedVisibility(
                    !settingSelected,
                    enter = fadeIn(animationSpec = tween(DURATION_ENTER)),
                    exit = fadeOut(animationSpec = tween(DURATION_EXIT))
                ) {
                    Column(
                        Modifier.fillMaxWidth(),
                        horizontalAlignment = Alignment.CenterHorizontally
                    ) {
                        SourceListView(navController = nav) {
                            nav.navigate("${Screen.Play.route}/${it.name.encodeBase64UrlSafe()}")
                        }
                    }
                }

                AnimatedVisibility(
                    settingSelected,
                    enter = fadeIn(animationSpec = tween(DURATION_ENTER)),
                    exit = fadeOut(animationSpec = tween(DURATION_EXIT))
                ) {
                    Column(
                        Modifier.fillMaxWidth(),
                        horizontalAlignment = Alignment.CenterHorizontally
                    ) {
                        SettingsListView(onOpenAiProviders = {
                            nav.navigate(AI_PROVIDER_ROUTE) { launchSingleTop = true }
                        }, onOpenAiCreations = {
                            nav.navigate(AI_CREATIONS_ROUTE) { launchSingleTop = true }
                        })
                    }
                }

            }
        }
    }
    }
}


sealed class Screen(
    val route: String,
    val resourceString: StringResource,
    val icon: ImageVector,
    val selectedIcon: ImageVector
) {
    data object Sources :
        Screen("sources", Res.string.sources, Icons.Outlined.Folder, Icons.Filled.Folder)

    data object Settings :
        Screen("settings", Res.string.settings, Icons.Outlined.Settings, Icons.Filled.Settings)

    data object Play :
        Screen("Play", Res.string.auto_play, Icons.Outlined.PlayArrow, Icons.Filled.PlayArrow)

    data object Home :
        Screen("Home", Res.string.home, Icons.Outlined.Home, Icons.Filled.Home)

    data object Config :
        Screen("Config", Res.string.settings, Icons.Outlined.Settings, Icons.Filled.Settings)
}

val navItems = listOf(
    Screen.Sources,
    Screen.Settings,
)
